// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"f850596d","314":"3720562e","378":"ec3f5135","422":"55a051f5","869":"c45f7af0"}[chunkId] + ".chunk.js";
};